import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">
              {siteInfo.name}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteInfo.description.slice(0, 120)}...
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="text-xs text-foreground-500 bg-secondary-100 px-2.5 py-1 rounded-full">
                {siteInfo.status}
              </span>
              <span className="text-xs text-foreground-500">
                共 {siteInfo.totalChapters} 章
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">
              分类导航
            </h3>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                    <span className="text-foreground-400 ml-1">({cat.chapterCount}章)</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">
              关于我们
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  读者口碑
                </Link>
              </li>
              <li>
                <a
                  href={`mailto:${siteInfo.contactEmail}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供学习交流，请支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}